export const HUB_DESCRIPTIONS = {
  pulse: 'Follow market moves and trends across company groups.',
  discover: 'Browse the full company roster and find your next research idea.',
  news: 'Catch up on the latest company news and developments.',
  calendar: 'See upcoming earnings dates and estimated reporting windows.',
  insider: 'Review reported insider purchases and sales.',
  insider_board: 'Spot qualifying stock purchases by independent directors.',
  pharma: 'Explore drug pipelines, clinical milestones, and upcoming catalysts.',
  marketcap: 'Compare companies by market capitalization.',
  contest: 'Explore the employee research contest.'
};
